<template>
<div class="page">
    <van-tabs ref="tabs" color="#7181EB" title-active-color="#7181EB" v-model="active">
        <van-tab :title="item.title" v-for="(item, index) in navArray" :key="index">
            <salon-tab :userType="user_type" :status="item.status" />
        </van-tab>
    </van-tabs>
    <div class="footer td-fcc" v-if="user_type == Constants.USER_AGENT">
        <div class="btn td-fcc" @click="_onPressToNavigate('', 'addSalon')">发布沙龙</div>
    </div>
</div>
</template>

<script>
import Header from "../../components/Header";
import SalonTab from "../../components/salon/SalonTab";
import salonItem from "../../components/item/salonItem";
export default {
    components: {
        Header,
        SalonTab,
        salonItem,
    },
    data() {
        return {
            loading: false,
            user_type: this.Constants.USER_AGENT, //	student:学员，agent:代理商，master:传承师
            navArray: [{
                    title: this.Constants.SALON_TITLE0,
                    status: this.Constants.SALON_STATUS0
                },
                {
                    title: this.Constants.SALON_TITLE1,
                    status: this.Constants.SALON_STATUS1
                },
                {
                    title: this.Constants.SALON_TITLE2,
                    status: this.Constants.SALON_STATUS2
                },
                {
                    title: this.Constants.SALON_TITLE3,
                    status: this.Constants.SALON_STATUS3
                },
                {
                    title: this.Constants.SALON_TITLE4,
                    status: this.Constants.SALON_STATUS4
                },
            ],
            active: 0,
            page: 0,
            limit: 10,
            dataSources: [],
        };
    },
    created() {
        this._initTabNavArray();
    },
    mounted() {},
    methods: {
        onBack() {
            this.$router.back();
        },

        // 点击跳转
        _onPressToNavigate(pageTitle, path, query) {
            if (pageTitle) {
                query = {
                    ...query,
                    pageTitle,
                }
            }
            this.$router.push({
                path,
                query
            });
        },

        _onPressToWeb(url) {
            if(!url) return;
            console.log('url---->', url);
            window.location.href = url;
        },

        _initTabNavArray() {
            let {
                user_type
            } = this.$route.query;
            this.user_type = user_type || this.Constants.USER_AGENT;
            if (user_type !== this.Constants.USER_AGENT) {
                this.navArray = [{
                        title: this.Constants.SALON_TITLE2,
                        status: this.Constants.SALON_STATUS2
                    },
                    {
                        title: this.Constants.SALON_TITLE3,
                        status: this.Constants.SALON_STATUS3
                    },
                ];
            }
            console.log('this.navArray---->', this.navArray);
        }
    }
};
</script>

<style lang="less" scoped>
.page {
    height: 100vh;
    display: flex;
    flex-direction: column;
}

.scrollerView {
    position: relative;
    width: 100%;
    flex: 1;
}

.scroller {
    background: #f8f8f8;
}

.service {
    position: fixed;
    right: 15px;
    bottom: 100px;
    width: 55px;
    height: 55px;
}

.footer {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 10;
    background-color: #fff;
    padding: 10px;
    box-shadow: 0 0 8px 4px rgba(0, 0, 0, 0.2);

    .btn {
        flex: 1;
        height: 40px;
        background: linear-gradient(225deg, #9cb2f4, #6472e8);
        border-radius: 3px;
        font-size: 15px;
        font-weight: 500;
        color: #ffffff;
    }
}
</style>
